import React from 'react'
import { pick } from 'lodash'
import { WrapIndication, IndicationLabel, CellWithButtonStyles } from './Style'
import { naLabel, ratingListLabel, ratingListTheme } from 'keys/rating'
import { gTheme } from 'styles/theme'
import { statuses } from 'keys'
import { Tooltip } from '@mui/material'
import { CellWithTooltipStyles } from 'components/Table/Style'
import { visibilityStatuses1 } from 'keys/visibilityStatuses'
import { secretStorage } from 'config'

const RateAndAccuracyValueCell = (props) => {
    const { row, column, cell } = props
    const value = cell.getValue()
    const { meta, accessorKey } = column.columnDef
    const is_superuser = secretStorage.getItem("user")?.is_superuser

    const { rating, status, assessment_hidden } = row.original || {}
    const { field, percent, index } = meta || {}

    const ratingFields = pick(rating, [index])
    let ratingIndex = ratingFields[index]
    let currentScoreRatingMethod

    if (status === statuses.brokenFile)
        currentScoreRatingMethod = {
            label: naLabel
        }

    else {
        currentScoreRatingMethod = {
            ratingLabel: ratingListLabel?.[ratingIndex - 1],
            themeColor: ratingListTheme?.[ratingIndex - 1],
            label: value ? `${value}${percent ? "%" : ""}` : ""
        }
    }

    const { label, themeColor, ratingLabel } = currentScoreRatingMethod
    const color = gTheme?.[themeColor]?.main || 'ligthGray'
    const hiddenAssessment = assessment_hidden && !is_superuser

    return (
        <CellWithButtonStyles>
            <CellWithTooltipStyles size={percent ? "md" : "sm"}>
                <Tooltip title={ratingLabel} placement='top'>
                    <WrapIndication>
                        <IndicationLabel color={hiddenAssessment || color}>
                            {label && `${label}`}
                        </IndicationLabel>
                    </WrapIndication>
                </Tooltip>
            </CellWithTooltipStyles>
        </CellWithButtonStyles>
    )
}

export default RateAndAccuracyValueCell